import { FC } from 'react';
import { IconSvgProps } from '@utmb/types/icons';

const StartWs: FC<IconSvgProps> = ({ color, clss, width, height }) => {
    return (
        <svg width={width} height={height} className={clss} id="Calque_2" data-name="Calque 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 432.1 432.1">
            <polygon
                fill={color}
                points="213.5 222.29 157.05 124.55 114.38 298.26 156.08 298.26 171.18 224.11 213.5 310.78 254.33 219.26 274.43 298.26 317.72 298.26 264.49 113.82 213.5 222.29"
            />
        </svg>
    );
};

export default StartWs;
